// helpers.js
import Web3 from 'web3';
const web3 = new Web3();
export const fromWeiToEther = (value) => {
    return web3.utils.fromWei(value.toString(), 'ether');
};

export const slicedAddress = (address) => {
    const result = `${address?.slice(0, 5)}....${address?.slice(-5)}`;
    return result;
};


